import { Injectable } from '@angular/core';
import {
  DeviceSettingResponse,
  DeviceSettingUpdateRequest,
  ShipmentDeviceSettingRequest,
} from '@entities/deviceSetting';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShipmentDeviceSettingService {
  constructor(private api: ApiService) {}

  /**
   * 配送時に反映されるデバイス詳細設定の一覧を取得する
   * @param shipmentId 配送ID
   * @returns トラッカー情報一覧
   */
  findList(shipmentId: string): Observable<DeviceSettingResponse[]> {
    const url = `/devices/configs/shipments/${shipmentId}`;
    return this.api.get<DeviceSettingResponse[]>(url);
  }

  /**
   * 配送時に反映されるデバイス詳細設定を追加する
   * @param request 登録内容
   */
  add(request: ShipmentDeviceSettingRequest[]): Observable<void> {
    const url = `/devices/configs/bulk/shipments`;
    return this.api.post<void>(url, request);
  }

  /**
   * 配送時に反映されるデバイス詳細設定を更新する
   * @param shipmentId 配送ID
   * @param request 更新内容
   */
  update(
    shipmentId: string,
    request: DeviceSettingUpdateRequest[],
  ): Observable<void> {
    const url = `/devices/configs/shipments/${shipmentId}`;
    return this.api.put<void>(url, request);
  }

  /**
   * 配送時に反映されるデバイス詳細設定を削除する
   * @param shipmentId 配送ID
   */
  delete(shipmentIdList: string[]): Observable<void> {
    const url = `/devices/configs/shipments/_delete`;
    return this.api.post<void>(url, shipmentIdList);
  }
}
